import styled from 'styled-components'
// TODO change library
import { Modal } from 'reactstrap'
import { device, colors } from 'Styled/variables'

export const ChangeSpotifyBlockDesktop = styled.div`
  position: absolute;
  right: 24px;
  top: 39px;
`

export const ChangeSpotifyBlockMobile = styled.div`
  position: sticky;
  left: 72px;
  bottom: 0px;
  margin-top: 16px;
  height: 40px;
`

export const SpotifyUrlFormWrapper = styled.div`
  position: relative;
`

export const WrapperRelative = styled.div`
  position: absolute;
  top: 174px;
  left: 25px;
  right: 25px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
`

export const WrapperForCloseBtn = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
`

export const SmallButton = styled.button`
  width: 40px;
  height: 40px;
  background-color: transparent;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  img {
    height: 10px;
  }
`

export const MobileModal = styled(Modal)`
  margin: 0;
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    width: 100%;
    height: 100%;
  }
  .modal.modal__mobile {
    display: block;
  }
  .modal-dialog .modal__mobile {
    margin: 0 !important;
  }
  .modal-open .modal {
    overflow-x: hidden;
    overflow-y: auto;
  }
  .modal__mobile-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
  }
  .modal__mobile-close {
    background-color: transparent;
    padding-right: 10px;
    color: ${colors.greyTextWhiteBg};
    opacity: 0.5;
  }
  .modal__mobile .modal__mobile-dialog {
    width: 100%;
    max-width: 100%;
    height: 100%;
    margin: 0px auto;
    margin-bottom: 1000px;
  }
  .modal-content {
    border-radius: 0px;
    height: 100%;
    margin-bottom: 500px;
    position: fixed;
    text-align: left;
    background-color: ${colors.white};
  }
  .modal__mobile .modal__mobile-dialog .modal-content {
    border-radius: 0px;
    height: 100%;
    margin-bottom: 500px;
    position: fixed;
  }
`
export const Arrow = styled.button`
  position: absolute;
  margin-right: 8px;
  left: 18px;
  top: 16px;
  background-color: transparent;
  cursor: pointer;
  z-index: 2000;
  height: 25px;
  width: 25px;
`
export const AddTrackItem = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
  color: ${colors.mainText};
  margin-bottom: 16px;
  margin-left: -139px;
  &:last-child {
    margin-bottom: 0px;
  }
`

export const AddTrackInfo = styled.div`
  display: flex;

  @media ${device.mobileMin} {
    display: flex;
    flex-direction: row;
    flex: 1 1;
    align-items: center;
  }
`

export const AddTrackUrl = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 4px;
  margin-right: 16px;
`

export const AddTrackInfoDescr = styled.div`
  padding: 0px;
  margin-bottom: 0px;
`

export const AddTrackInfoTitle = styled.div`
  font-weight: 600;
  line-height: 21px;
`
